import useLocalStore from '../../../hooks/useLocalStore.js';
import FJVoiceCloningList from '../view/FJVoiceCloningList.jsx';
import FJSelectAll from '../../../common/components/FJSelectAll/FJSelectAll.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FJActionVoiceCloning from '../../../redux/action/FJActionVoiceCloning.js';
import FJConstant from '../../../constants/FJConstant.js';
import { setSliceSelectListAction } from '../../../redux/slices/FJSliceCommon.js';
import FJAudioPlayManager from '../../../store/FJAudioPlayManager.js';
import FJActionCommon from '../../../redux/action/FJActionCommon.js';
import FJLocalStore from '../../../store/FJLocalStore.js';
import { useEffect, useCallback } from 'react';
import FJKeymap from '../../../util/FJKeymap.js';
import FJAppConstant from '../../../constants/FJAppConstant.js';

const FJVoiceCloningListContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const appType = useSelector(state => state.common.appType);
    const historyList = useSelector(state => state.common.historyList);

    const selectList = useSelector(state => state.common.selectList);
    const isMultipleMode = useSelector(state => state.common.isMultipleMode);

    const setIsMultipleMode = bool => {
        dispatch(FJActionCommon.setIsMultipleModeAction(bool));
        FJAudioPlayManager.pauseAll();
    };

    const _toCreateClone = () => {
        dispatch(FJActionVoiceCloning.setCreateCloneStatusAction(FJConstant.DEFAULT));
        setIsMultipleMode(false);
        _setSliceSelectList([]);
    };

    const _multiDelete = ids => {
        FJAudioPlayManager.pauseAll();
        dispatch(FJActionCommon.multiDeleteAction(ids, undefined, { type: FJConstant.CLONE_VOICE }));
    };

    const _clearSelected = () => {
        setIsMultipleMode(false);
    };

    const _setSliceSelectList = value => {
        dispatch(setSliceSelectListAction(value));
    };

    const _keyDown = useCallback(
        e => {
            if (e.code === 'Escape') {
                if (FJKeymap.getScope() === 'default') {
                    _setSliceSelectList([]);
                    setIsMultipleMode(false);
                }
            }
        },
        [_setSliceSelectList],
    );

    useEffect(() => {
        window.addEventListener('keydown', _keyDown);
        return () => {
            window.removeEventListener('keydown', _keyDown);
        };
        //TODO 业务需要此依赖
    }, [_keyDown, isMultipleMode]);

    return (
        <>
            <FJVoiceCloningList list={historyList} toCreateClone={_toCreateClone} isMultipleMode={isMultipleMode} />
            <FJSelectAll
                appType={FJAppConstant.AI_VOICE_CLONING}
                list={historyList}
                selectList={selectList}
                setSelectList={_setSliceSelectList}
                multiDelete={_multiDelete}
                isMultipleMode={isMultipleMode}
                clearSelected={_clearSelected}
                isShowAddToMediaButton={window.isEditPage}
                selectedText={FJLocalStore._(selectList.length < 2 ? 'voice-selected' : 'voices-selected')}
                hideDownload={true}
            />
        </>
    );
};
export default FJVoiceCloningListContainer;
